<div class="support-page-skeleton">
  <section class="-hero">
    <div class="-hero-left">
      <wp-skeleton class="-title" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-description" [loading]="true"></wp-skeleton>
    </div>

    <div class="-hero-right">
      <wp-skeleton class="-eyebrow" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-help-title" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-help-copy" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-button" [loading]="true"></wp-skeleton>
    </div>
  </section>

  <wp-skeleton class="-divider" [loading]="true"></wp-skeleton>
@for (section of [1, 2, 3]; track section) {
  <section class="-cards">
    @for (card of [1, 2, 3]; track card) {
    <div class="-card">
      <div class="-card-header">
        <wp-skeleton class="-icon" [loading]="true"></wp-skeleton>
        <wp-skeleton class="-card-title" [loading]="true"></wp-skeleton>
      </div>
      <wp-skeleton class="-card-line" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-card-line -short" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-card-link" [loading]="true"></wp-skeleton>
    </div>
    }
  </section>
}
</div>
